import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/var/www/kanoon-stage/frontend/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import Layout from "../components/sidebarPro";
import Head from "next/head";
import styles from "../assets/css/register.module.css";
import { useRouter } from "next/router";
import axios from "axios";
import Footer from "../components/footer/Footer";
import Link from "next/link";
import ButtonLoading from "../components/buttonLoading";
import { baseUrl } from '../api';
import { loginKanoon } from "../api/requests";
import useTranslation from "next-translate/useTranslation";

var LoginWithKanoon = function LoginWithKanoon() {
  var router = useRouter();

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState({
    KanoonID: "",
    Password: ""
  }),
      input = _useState2[0],
      setInput = _useState2[1];

  var _useState3 = useState(),
      error = _useState3[0],
      setError = _useState3[1];

  var _useState4 = useState(),
      serverResponse = _useState4[0],
      setServerResponse = _useState4[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var handleChange = function handleChange(_ref) {
    var _ref$target = _ref.target,
        name = _ref$target.name,
        value = _ref$target.value,
        checked = _ref$target.checked,
        type = _ref$target.type;
    setError(null);
    var inputValue = type === "checkbox" || type === "radio" ? checked : value;
    setInput(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, name, inputValue));
    });
  };

  var handleSubmitKanoonId = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var KanoonID, Password, fromApp, validated, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              KanoonID = input.KanoonID, Password = input.Password;
              fromApp = false;
              validated = ValidateKanoonId();

              if (!validated) {
                _context.next = 25;
                break;
              }

              setLoading(true);
              _context.prev = 6;
              _context.next = 9;
              return loginKanoon(input.KanoonID, input.Password, fromApp);

            case 9:
              res = _context.sent;
              setServerResponse(res.data);
              setLoading(false); // console.log("login with kanoon res: ", res);

              localStorage.setItem('Username', res.data.FullName);
              localStorage.setItem('token', res.data.token);
              localStorage.setItem('Counter', input.KanoonID);
              localStorage.setItem('isLogin', "true"); // setContext(res.data)

              _context.next = 18;
              return router.push('/');

            case 18:
              _context.next = 25;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](6);
              console.log("login with kanoon error", _context.t0);

              if (_context.t0 && _context.t0.response && _context.t0.response.data && _context.t0.response.data.message) {
                setServerResponse(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    message: _context.t0.response.data.message
                  });
                });
              } else {
                setServerResponse(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    message: "There was a problem, Please try again"
                  });
                });
              }

              setLoading(false); // return Promise.reject(error);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 20]]);
    }));

    return function handleSubmitKanoonId(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var ValidateKanoonId = function ValidateKanoonId() {
    var validated = true; // console.log("input.KanoonID.length",input.KanoonID.length)
    // console.log("input.KanoonID",input.KanoonID)

    if (input.KanoonID && input.KanoonID.length !== 9) {
      setError(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          KanoonID: "Kanoon ID must be 9 digits long"
        });
      });
      validated = false;
    }

    if (isNaN(Number(input.KanoonID))) {
      // console.log("typeof(input.CellPhoneNum) from inside: ", typeof (input.KanoonID))
      setError(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          KanoonID: "Kanoon ID must be only numbers"
        });
      });
      validated = false;
    }

    if (!input.KanoonID) {
      setError(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          KanoonID: "KanoonID field must be filled"
        });
      });
      validated = false;
    }

    if (input.Password && input.Password.length < 6) {
      // console.log("input.CellPhoneNum.length",input.KanoonID.length)
      setError(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          Password: "Password must be longer than 6 digits"
        });
      });
      validated = false;
    }

    if (!input.Password) {
      setError(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          Password: "Password field must be filled"
        });
      });
      validated = false;
    }

    return validated;
  };

  return /*#__PURE__*/_jsxs(Layout, {
    page: "login with Kanoon",
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsx("title", {
        children: isRTL ? "ورود با حساب کانون - دنیای واژه ها" : "Login with Kanoon ID - wow kanoon"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        href: "/images/logos/favicon.png"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.register,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.container,
        children: [/*#__PURE__*/_jsx("p", {
          className: "mt-3 mb-3 ".concat(styles.darkBlue, " ").concat(styles.title),
          children: t('loginWithKanoon:LOGIN')
        }), /*#__PURE__*/_jsxs("form", {
          children: [/*#__PURE__*/_jsx("p", {
            children: t('loginWithKanoon:Please enter your kanoon ID')
          }), serverResponse && /*#__PURE__*/_jsx("label", {
            className: styles.rtl,
            children: serverResponse.message
          }), /*#__PURE__*/_jsx("label", {
            className: styles.formError,
            children: error && error.KanoonID ? error.KanoonID : ""
          }), /*#__PURE__*/_jsx("input", {
            className: "".concat(styles.form, " form-control d-inline-block ").concat(error && error.KanoonID ? styles.isInvalid : "is-valid"),
            placeholder: t('loginWithKanoon:Kanoon ID number'),
            onChange: handleChange,
            value: input.KanoonID,
            name: "KanoonID",
            id: "mobile-icon",
            style: {
              fontFamily: isRTL ? "Yekan" : "Helvetica",
              textAlign: isRTL ? "right" : "left",
              textIndent: isRTL ? "0" : 40
            }
          }), /*#__PURE__*/_jsx("label", {
            className: styles.formError,
            children: error && error.Password ? error.Password : ""
          }), /*#__PURE__*/_jsx("input", {
            className: "".concat(styles.form, " form-control d-inline-block ").concat(error && error.Password ? styles.isInvalid : "is-valid"),
            placeholder: t('loginWithKanoon:Password'),
            onChange: handleChange,
            value: input.Password,
            name: "Password",
            id: "lock-icon",
            type: "password",
            style: {
              fontFamily: isRTL ? "Yekan" : "Helvetica",
              textAlign: isRTL ? "right" : "left",
              textIndent: isRTL ? "0" : 40
            }
          }), /*#__PURE__*/_jsx("button", {
            type: "submit",
            className: ['btn text-white mt-4', styles.registerBtn, loading ? styles.disable : ''].join(' '),
            onClick: loading ? "" : handleSubmitKanoonId,
            children: loading ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(ButtonLoading, {}), /*#__PURE__*/_jsx("span", {
                children: "loading"
              })]
            }) : /*#__PURE__*/_jsx(_Fragment, {
              children: t('loginWithKanoon:Login')
            })
          }), /*#__PURE__*/_jsx("p", {
            className: "".concat(styles.darkBlue, " pt-1 mb-1"),
            children: "or"
          }), /*#__PURE__*/_jsx(Link, {
            href: "/verifyPhone",
            children: /*#__PURE__*/_jsx("a", {
              children: /*#__PURE__*/_jsx("button", {
                className: "btn ".concat(styles.wowBtn, " ").concat(isRTL ? styles.wowBtnFa : '', " mb-5"),
                children: t('loginWithKanoon:Login with WOW')
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.loginFooter,
      children: /*#__PURE__*/_jsx(Footer, {})
    })]
  });
};

export var __N_SSG = true;
export default LoginWithKanoon;